module.exports = __webpack_public_path__ + "img/plant_7_small.7667d92a.webp";